import Link from 'next/link';
import { DEFAULT_LOGO_PROPS } from './Logo.constants';
import { LogoProps } from './Logo.interfaces';
import { getValidClassNames } from '@/utils';

export const Logo = (logo: LogoProps) => {
  const logoProps: LogoProps = {
    ...DEFAULT_LOGO_PROPS,
    ...logo,
  };

  const Component = logo.as ?? Link;

  return (
    <Component
      className={getValidClassNames({
        'c-logo': true,
        [`c-logo-${logo.size}`]: Boolean(logo.size),
      })}
      href={String(logoProps.href)}
    >
      {/* <span className="sr-only">{logoProps.label}</span> */}
      <img alt={logoProps.image?.altText ?? logoProps.label} className="c-logo__image" src={logoProps.image?.src} />
    </Component>
  );
};
